import List from './List';
import View from './View';

export default {
  List,
  View,
};
